import GLightbox from 'glightbox';

// "Video bekijken"-knoppen (.glightbox-video): speelt de video af in een lightbox
export default function () {
    if (document.querySelector('.glightbox-video') === null) {
        return;
    }

    const bgVideo = document.querySelector('.home-banner-video iframe');

    const lightbox = GLightbox({
        selector: '.glightbox-video',
        autoplayVideos: true,
        touchNavigation: false,
        plyr: {
            config: {
                vimeo: { autopause: false },
            },
        },
    });

    // Achtergrondvideo (homepage) na sluiten weer laten spelen
    lightbox.on('close', () => {
        if (bgVideo) {
            bgVideo.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        }
    });
}
